import { SET_PAGE_TYPE } from 'actions/page';

const DEFAULT_STATE = {
  pageType: undefined
};

export default function page(state = DEFAULT_STATE, action) {
  const { type, pageType } = action;
  switch (type) {
    case SET_PAGE_TYPE:
      return { ...state, pageType };
    default:
      return state;
  }
}
